import React, { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { useParams,useNavigate,Link } from 'react-router-dom'
import { apiurl,staticurl } from '../common/constants'
import { useAuthAxios } from './authfetch'
import Footer from "./Footer"
import ItemCard from './ItemCard'
import OrderModal from './OrderModal';
import {
    SideBySideMagnifier,
  } from "sunzi-image-magnifiers";

import { SignedIn, SignedOut, SignInButton, useAuth } from '@clerk/clerk-react';
import { useStore } from '../context/StoreContext'


export default function IndividualProduct() {
    const params = useParams()
    const [productId,setProductId] = useState(params.productId)
    const [product,setProduct] = useState(null)
    // eslint-disable-next-line
    const [matches, setMatches] = useState(window.matchMedia("(min-width: 768px)").matches)
    const [mainImage,setMainImage] = useState(null)
    const [fetchedBrandproduct,setfetchedBrandproduct] = useState(null)
    const [similarProduct,setSimilarProduct] = useState(null)
    const [isLoggedIn,setIsLoggedIn] = useState(false)
    
    // Dynamic Height calculation refs
    const imageRef = useRef(null);
    const topContentRef = useRef(null);
    const bottomContentRef = useRef(null);
    const [descMaxHeight, setDescMaxHeight] = useState('200px');
    const authAxios = useAuthAxios();

    const { getToken } = useAuth();

    // store
    const {openOrderForm,setOpenOrderForm,setIsLoading,productRefresh, selectProductForEdit,setToast, isOrderingEnabled, isAdmin} = useStore();


    const handleOrderSubmit = async (formData) => {
        try{
            setIsLoading(true);
            const { data } = await authAxios.post(apiurl+"/orders", formData);
            if (data.statusCode < 400){
                setToast({show:true,type:"success",message:data.message})
            }else{
                setToast({show:true,type:"error",message:data.message})
            }
        }catch(err){
            setToast({show:true,type:"error",message:err.response.data.message})
            console.error(err)
        }finally{
            setIsLoading(false);
        }
    };

    // const firstRender = useRef({productFirstRender:true,brandFirstRender:true})

    const navigate = useNavigate()


    const handleGalleryImgClick = (url) =>{
        // alert(url)
        setMainImage(url)
    }
    useEffect(()=>{
        setProductId(params.productId)
        window.scrollTo(0, 0);
    },[params.productId])

    useEffect(() => {
        const fetchProduct = async () => {
            setIsLoading(true);
            try {
                const { data } = await authAxios.get(`${apiurl}/products/get/${productId}`);
                if (data.productFound === 0){
                    document.querySelector(".container").innerHTML = "<h1>product not available or has been deleted</h1>"
                }
                // add to recently viewed page if not present
                if (localStorage.getItem('recentviews')){
                    const recentviewsJson = JSON.parse(localStorage.getItem('recentviews'))
                    let recentviewsMap = new Map(recentviewsJson)
                    
                    if (recentviewsMap.has(data.data._id)){
                        recentviewsMap.delete(data.data._id)
                    }
                    recentviewsMap = new Map([[data.data._id, {_id:data.data._id,prod_name:data.data.prod_name,prod_thumbnail:data.data.prod_thumbnail,price:data.data.price,discounted_price:data.data.discounted_price,stock:data.data.stock,timestamp: new Date().getTime()}], ...recentviewsMap]);
                    localStorage.setItem('recentviews',JSON.stringify(Array.from(recentviewsMap)))
                }
                else{
                    let recentviewsMap = new Map()
                    recentviewsMap.set(data.data._id,{
                        _id:data.data._id,
                        prod_name:data.data.prod_name,
                        prod_thumbnail:data.data.prod_thumbnail,
                        timestamp: new Date().getTime()
                    })
                    localStorage.setItem('recentviews',JSON.stringify(Array.from(recentviewsMap)))
                }

                setProduct(data.data)                
                setMainImage(data.data.prod_img[0])
            } catch (err) {
                console.log(err)
            } finally {
                setIsLoading(false)
            }
        };
        fetchProduct();
             
        if (isAdmin){
            setIsLoggedIn(true)
        }
    }, [productId, productRefresh])
    
    useEffect(() => {
        const fetchRelatedProducts = async () => {
            if (product){
                // 3 for lg devices to cover the space and 4 for sm and xs devices row-cols-2
                const productPerPage = matches ? 5 : 6;
                
                if (product.brand_ref !== null){
                    try {
                        const { data } = await authAxios.post(`${apiurl}/brands/getbrandproduct`, {
                            _id: product.brand_ref._id,
                            pageNumber: 1,
                            productPerPage,
                            exclude: product._id
                        });
                        setfetchedBrandproduct(data.data.products);
                    } catch (err) {
                        console.log(err);
                    }
                }
                
                // similar product fetch
                const similarProductCount = 15;
                try {
                    const { data } = await authAxios.post(`${apiurl}/search`, {
                        category_ref: product.category_ref._id,
                        productPerPage: similarProductCount,
                        excludeProductId: product._id,
                        latest: true
                    });
                    setSimilarProduct(data.data);
                } catch (err) {
                    console.log(err);
                }
            }
        };
        fetchRelatedProducts();
    }, [product, productId]);

    // Recalculate description height
    useLayoutEffect(() => {
        const calculateHeight = () => {
             // Only apply dynamic height on larger screens where there are 2 columns
            if (window.innerWidth >= 992 && imageRef.current && topContentRef.current && bottomContentRef.current) {
                const imgHeight = imageRef.current.getBoundingClientRect().height;
                const topHeight = topContentRef.current.getBoundingClientRect().height;
                const bottomHeight = bottomContentRef.current.getBoundingClientRect().height;
                
                // Available height = Image Height - Top Content - Bottom Content - Margins/Padding buffer
                // Buffer of ~60px for margins between elements
                const availableHeight = imgHeight - topHeight - bottomHeight - 60;
                
                // Ensure absolute minimum of 200px
                const finalHeight = Math.max(200, availableHeight);
                setDescMaxHeight(`${finalHeight}px`);
            } else {
                setDescMaxHeight('200px');
            }
        };

        calculateHeight();
        
        window.addEventListener('resize', calculateHeight);

        return () => window.removeEventListener('resize', calculateHeight);
    }, [product, mainImage]);

    

    return (
        <>
            <div className='container py-5' style={{minHeight:"80vh"}}>
                {/* <EditProductDetail setSimilarProduct={setSimilarProduct} product={product} setProductRefresh={setProductRefresh} productRefresh={productRefresh} /> */}
                
                {product ? (
                    <div className='row g-5'>
                        {/* Left Column: Product Images */}
                        <div className='col-lg-6 col-12' ref={imageRef}>
                            <div className='card border-0'>
                                <div className='magnifier position-relative overflow-hidden rounded shadow-sm' style={{border: "1px solid #eee"}}>
                                    <SideBySideMagnifier
                                        style={{height:"100%", width: "100%"}}
                                        imageSrc= {staticurl + mainImage}
                                        imageAlt={product.prod_name}
                                        alwaysInPlace={true}
                                        overlayBoxImageSize="200%"
                                    />
                                    {/* Edit Icon for logged in users */}
                                     {isLoggedIn && (
                                        <div className="position-absolute top-0 end-0 p-2">
                                            <button onClick={()=>selectProductForEdit(product)} className="btn btn-sm btn-light rounded-circle shadow-sm" data-bs-toggle="modal" data-bs-target="#editProductDetailModel">
                                                <i className="fa-solid fa-pen-to-square text-dark"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                                
                                {/* Thumbnails */}
                                {product.prod_img.length > 1 && (
                                    <div className='d-flex gap-2 mt-3 overflow-auto pb-2'>
                                        {product.prod_img.map((img, index) => (
                                            <div 
                                                key={index}
                                                className={`cursor-pointer border rounded overflow-hidden ${mainImage === img ? 'border-dark' : 'border-light'}`}
                                                style={{width: "80px", height: "80px", flexShrink: 0}}
                                                onClick={() => handleGalleryImgClick(img)}
                                            >
                                                <img 
                                                    src={staticurl + img.replace("/products/", "/thumbnails/")} 
                                                    alt={`thumbnail-${index}`} 
                                                    className="w-100 h-100 object-fit-cover"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Right Column: Product Details */}
                        <div className='col-lg-6 col-12'>
                            <div className="ps-lg-4">
                                <div ref={topContentRef}>
                                    <nav aria-label="breadcrumb" className="mb-3">
                                        <ol className="breadcrumb small text-muted">
                                            <li className="breadcrumb-item"><Link to="/" className="text-decoration-none text-muted">Home</Link></li>
                                            {product.category_ref && <li className="breadcrumb-item">{product.category_ref.category_name}</li>}
                                            <li className="breadcrumb-item active" aria-current="page">{product.prod_name}</li>
                                        </ol>
                                    </nav>

                                    <h1 className='display-6 fw-bold mb-3'>{product.prod_name}</h1>
                                    
                                    <div className="d-flex align-items-center mb-4">
                                        <div style={{ display: 'none' }}>
                                        {product.discounted_price ? (
                                            <div className="d-flex flex-column me-3">
                                                <h3 className="mb-0 text-dark fw-bold">Rs. {product.discounted_price}</h3>
                                                <span className="text-muted text-decoration-line-through">Rs. {product.price} </span>
                                            </div>
                                        ) : (
                                            <h3 className="mb-0 me-3 text-dark fw-bold">Rs. {product.price || 0}</h3>
                                        )}
                                        </div>
                                        {(product.stock && product.stock > 0) ? (
                                            <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill px-3">In Stock</span>
                                        ) : (
                                            <span className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill px-3">Out of Stock</span>
                                        )}
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h5 className="fw-bold mb-2">Description</h5>
                                    <p className="text-muted pe-2" style={{lineHeight: "1.7", whiteSpace: "pre-line", maxHeight: descMaxHeight, overflowY: "auto", transition: "max-height 0.3s ease"}}>
                                        {product.prod_desc}
                                    </p>
                                </div>

                                <div ref={bottomContentRef}>
                                    <div className="d-grid gap-2 mb-5">
                                        {isOrderingEnabled && (
                                        <>
                                        <SignedOut>
                                            <SignInButton mode="modal">
                                                <button className="btn btn-dark btn-lg py-3 rounded-1">
                                                    Order Now
                                                </button>
                                            </SignInButton>
                                        </SignedOut>
                                        <SignedIn>
                                            <button 
                                                className={`btn btn-dark btn-lg py-3 rounded-1 ${(product.stock > 0 || product.pre_order) ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                                onClick={() => setOpenOrderForm(true)}
                                                disabled={!(product.stock > 0 || product.pre_order)}
                                            >
                                                <i className="fa-solid fa-cart-shopping me-2"></i> {product.pre_order ? "Pre Order" : "Place Order"}
                                            </button>
                                            <OrderModal 
                                                show={openOrderForm} 
                                                handleClose={() => setOpenOrderForm(false)} 
                                                onSubmit={handleOrderSubmit} 
                                                product={product} 
                                            />
                                        </SignedIn>
                                        </>
                                        )}
                                    </div>
                                    
                                    {product.brand_ref && (
                                        <div className="border-top pt-4">
                                            <p className="text-muted small mb-1">Brand</p>
                                            <Link to={`/brands/${product.brand_ref.brandName}`} className="text-decoration-none text-dark fw-bold fs-5">
                                                {product.brand_ref.brandName} <i className="fa-solid fa-arrow-right-long ms-2 small"></i>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="text-center py-5">
                        <div className="spinner-border text-secondary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>

            {/* Related Products Section */}
            {product && (
            <section className='bg-light py-5'>
                <div className='container'>
                    {/* Brand Products */}
                    {fetchedBrandproduct && fetchedBrandproduct.length > 0 && (
                        <div className="mb-5">
                            <h3 className='fw-bold mb-4'>More from {product.brand_ref?.brandName}</h3>
                            <div className='row row-cols-2 row-cols-md-4 row-cols-lg-5 g-4'>
                                {fetchedBrandproduct.map(elem => (
                                    <div className='col' key={elem._id}>
                                        <ItemCard img={elem}/>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Similar Products */}
                    {similarProduct && similarProduct.length > 0 && (
                        <div>
                            <h3 className='fw-bold mb-4'>Similar Products</h3>
                            <div className='row row-cols-2 row-cols-md-4 row-cols-lg-5 g-4'>
                                {similarProduct.map(elem => (
                                    <div className='col' key={elem._id}>
                                        <ItemCard img={elem}/>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </section>
            )}

            <Footer />
        </>
    )
}
